var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.74856 10.7883C2.67702 10.79 0.998896 12.4704 1 14.5419C1.00111 16.6134 2.68102 18.292 4.75256 18.2915C6.8241 18.2909 8.50313 16.6114 8.50313 14.5399C8.50286 13.5445 8.10711 12.59 7.40296 11.8864C6.69882 11.1828 5.74398 10.7878 4.74856 10.7883Z",
    stroke: "#00AEFF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2469 10.7883C13.1754 10.79 11.4972 12.4704 11.4984 14.5419C11.4995 16.6134 13.1794 18.292 15.2509 18.2915C17.3225 18.2909 19.0015 16.6114 19.0015 14.5399C19.0012 13.5445 18.6055 12.59 17.9013 11.8864C17.1972 11.1828 16.2423 10.7878 15.2469 10.7883V10.7883Z",
    stroke: "#00AEFF",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99777 1.70856C7.92623 1.71022 6.2481 3.39058 6.24921 5.46212C6.25031 7.53366 7.93023 9.21223 10.0018 9.21168C12.0733 9.21113 13.7523 7.53166 13.7523 5.46012C13.7521 4.46471 13.3563 3.51018 12.6522 2.8066C11.948 2.10301 10.9932 1.70803 9.99777 1.70856Z",
    stroke: "#00AEFF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclesIcon);
export default __webpack_public_path__ + "static/media/circles-icon.3115b03fe1b75c82e014069d63f4e432.svg";
export { ForwardRef as ReactComponent };